import React, { Component, Fragment } from 'react';
import './bcac.css';
import BillBoard from './billBoard';
import MultiDatePicker from '../../Misc/multiDatePicker/multiDatePicker';
import {_addNotificationError, convertTwoDecimalPoint} from '../../../server/util';
const paymentMethods={
    'CASH' : 'Cash/Check payment',
    'CARD':'Card payment'
};
class BcacPackage extends Component {
    
    render() {
        const {students, packageList, currency, paymentType}=this.props;
        return ( 
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="panel panel-default">
                            <div className="panel-body">
                                <div className="border_thumb">
                                    <div className="row">
                                        <div className="col-md-12">      
                                            <div className="caption bcacBox">
                                                <div className="leftBox">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <h5>Purchase BCAC Package</h5>
                                                        </div>
                                                        <div className="col-md-6 text-right">
                                                            <button className="btn btn-xs btn-success" style={{margin:'0px'}} onClick={()=>{
                                                                this.props.jumpToStep(0);
                                                            }}>Edit Registration Details</button>     
                                                        </div>
                                                    </div>
                                                    <hr style={{margin:'5px'}} />                                                   
                                                    {
                                                        Object.keys(students||{}).map((sid,i)=>{
                                                            const _packageList=students[sid].packageList||[];
                                                            const fullName=`${students[sid].lastName}, ${students[sid].firstName}`;
                                                            if((!students[sid].isRegistered) && (!students[sid].isSelected) ){
                                                                return null
                                                            }else{
                                                                return _packageList.map((pack,j)=>{
                                                                    return <div className="row form-group">
                                                                    <div className="col-md-4">
                                                                        <label>{fullName}</label>
                                                                    </div>
                                                                    <div className="col-md-5">
                                                                    <select className="form-control" name="packageId" value={pack.packageId} onChange={(e)=>{
                                                                        const pkg=(packageList||[]).find(itm=>{
                                                                            return itm.id==e.target.value;
                                                                        })
                                                                        this.props.onPackageSelected(sid,pkg,j,e);
                                                                    }}>
                                                                        <option></option>
                                                                        {
                                                                            (packageList||[]).filter((itm)=>{
                                                                                return itm.type=='Package';
                                                                            }).map((item,k)=>{
                                                                            return <option key={k} value={item.id}>
                                                                                {`${item.packageName}-${item.frequency}-${currency} ${item.price}`}
                                                                                </option>
                                                                            })
                                                                        }                                                                    
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                    {
                                                                        pack.frequency==='One Time'?
                                                                        <MultiDatePicker 
                                                                        {...this.props}
                                                                        selectedDates={[...pack.dateList]}
                                                                        previousPaidDates={pack.previousBookedDates||[]}
                                                                        onSelectedDate={(date)=>{                                                                            
                                                                            this.props.addDates(sid,date);
                                                                        }}
                                                                        onDateRemove={(index)=>{
                                                                            this.props.removeDates(sid,index);
                                                                        }} />
                                                                        :
                                                                        <input className="form-control" name="freqText" disabled={true} value={pack.freqText} type="text" />
                                                                    }                                                                                                                          
                                                                    </div>
                                                                </div>
                                                                })
                                                            }
                                                        })
                                                    }
                                                </div>
                                                <div className="rightBox">
                                                    <BillBoard {...this.props} />
                                                </div>                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="panel-footer">
                                    <div className="row">
                                        <div className="col-md-4 pull-right">
                                            <div style={{paddingLeft: '30px'}}>
                                            {
                                               Object.keys(paymentMethods).map((key,i)=>{
                                                   return (<Fragment> <div className="c_checkbox c_checkbox-inline c_checkbox-primary">
                                                        <input type="checkbox" id={`paymentType${i}`} checked={paymentType===key} name="paymentType" value={key} 
                                                            onChange={(e)=>{
                                                            this.props.onChangePaymentType(e.target.checked?key:'');
                                                        }} 
                                                        />
                                                        <label htmlFor={`paymentType${i}`} style={{lineHeight:'20px'}}>{paymentMethods[key]}</label>
                                                    </div>
                                                      <br />
                                                    </Fragment>)
                                               })                                                
                                            }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                <div className="col-xs-12">
                <button className="btn btn-prev btn-xs bg-color-2 pull-let" onClick={(e)=>{
                        this.props.onChangePaymentType('');
                        this.props.jumpToStep(1)
                    }}>Previous
                    </button>
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{
                        let list=[];
                         Object.keys(students||{}).map((sid,i)=>{
                            const _packageList=students[sid].packageList||[];
                            if((students[sid].isRegistered) && (students[sid].isSelected) ){
                                _packageList.map((pack,j)=>{
                                    if(pack.frequency==='One Time'){
                                        if((pack.dateList||[]).length==0 && ((pack.packageId||'')!=='') ){
                                            list.push(pack);
                                        }
                                    }
                                })
                            }
                        })
                        if(list.length>0){
                            _addNotificationError('Please provide dates for selected package',this.props);
                        }else{
                            if(this.props.paymentType==='' && convertTwoDecimalPoint(this.props.totalAmount,2)>0){
                                _addNotificationError('Please select payment method',this.props);

                            }else{                           
                                this.props.jumpToStep(3);
                            }
                        }                        
                    }}>Next
                    </button>
                </div>
            </div>
            </Fragment>
         );
    }
}
 
export default BcacPackage;


// WEBPACK FOOTER //
// ./src/components/Parent/bcac/bcacPackage.jsx